import { InputGroup, InputGroupProps } from '@chakra-ui/react';
import React from 'react';

export const CmInputGroup: React.FC<InputGroupProps> = ({
  children,
  ...rest
}) => {
  // @ts-ignore TS2590
  return <InputGroup {...{ ...rest }}>{children}</InputGroup>;
};
